import * as moment from 'moment';
import {ISO_8601} from 'moment';
import { InvestmentPreference } from './finzy-flex/user-attribute.model';
import {Rating} from './portfolio-preferences.model';

export class Preferences {

    static ratingMappings = {
        // A_PLUS_1: Rating.APlus1, A_PLUS_2: Rating.APlus2, A_PLUS_3: Rating.APlus3,
        A_1: Rating.A1, A_2: Rating.A2, A_3: Rating.A3,
        A_4: Rating.A4, A_5: Rating.A5, A_6: Rating.A6,
        B_1: Rating.B1, B_2: Rating.B2, B_3: Rating.B3,
        B_4: Rating.B4, B_5: Rating.B5, B_6: Rating.B6,
        C_1: Rating.C1, C_2: Rating.C2, C_3: Rating.C3,
        C_4: Rating.C4, C_5: Rating.C5, C_6: Rating.C6
    };
    public userId: string;
    public updatedAt: Date;
    public reinvest: ReinvestPreferences;
    public preferredRatings: Set<Rating>;
    public automaticInvestmentsFromWallet: boolean;
    public allocatedLoanNotification: boolean;
    public investmentAttrs: InvestmentPreference[];
    public isNCashModified: boolean = false;
    public isSwiftModified: boolean = false;
    public investmentPreferences?: InvestmentPreference[];

    static from(preferencesAsJson: any): Preferences {
        if (preferencesAsJson) {
            const preferences = new Preferences();
            preferences.userId = preferencesAsJson.userId;
            preferences.reinvest = preferencesAsJson.reinvest;
            preferences.automaticInvestmentsFromWallet = preferencesAsJson.automaticInvestmentsFromWallet;
            preferences.allocatedLoanNotification = preferencesAsJson.allocatedLoanNotification;
            preferences.preferredRatings = new Set<Rating>(preferencesAsJson.preferredRatings);
            preferences.investmentAttrs = preferencesAsJson.investmentPreferences;
            preferences.updatedAt = preferencesAsJson.updatedAt ? moment(preferencesAsJson.updatedAt, ISO_8601).toDate() : undefined;
            preferences.isNCashModified = preferencesAsJson.isNCashModified;
            preferences.isSwiftModified = preferencesAsJson.isSwiftModified;
            return preferences;
        }
        return null;
    }

    public static createDefault(): Preferences {
        const defaultPreferences = new Preferences();
        defaultPreferences.reinvest = this.createReinvestDefault();
        defaultPreferences.automaticInvestmentsFromWallet = false;
        defaultPreferences.allocatedLoanNotification = false;
        defaultPreferences.preferredRatings = new Set<Rating>(Object.values(Rating));
        defaultPreferences.investmentAttrs = [];
        defaultPreferences.isNCashModified = false;
        defaultPreferences.isSwiftModified = false;
        return defaultPreferences;
    }

    public static convertRatingsFromLabels(ratingLabels: Set<string>): Set<Rating> {
        const convertedPreferredRatings = new Set<Rating>();
        ratingLabels.forEach(ratingLabel => {
            convertedPreferredRatings.add(this.ratingMappings[ratingLabel]);
        });
        return convertedPreferredRatings;
    }

    private static createReinvestDefault(): ReinvestPreferences {
        return {
            emi: {
                reinvestPrincipal: false,
                reinvestInterest: false
            },
            prepayment: {
                reinvestPrincipal: false,
                reinvestInterest: false
            }
        };
    }
}

export interface ReinvestPreferences {
    emi: PrincipalInterestPreferences;
    prepayment: PrincipalInterestPreferences;
}

export interface PrincipalInterestPreferences {
    reinvestPrincipal: boolean;
    reinvestInterest: boolean;
}
